import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-popup',
  templateUrl: './help-popup.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
